"use strict";

require("core-js/modules/es.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _FileUploadProgress = _interopRequireDefault(require("./components/FileUploadProgress"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _FileUploadProgress["default"];
exports["default"] = _default;